





















































import Vue from 'vue'
import SourceFilter from '@/components/source-filter.vue'
import { fetchSources } from '@/core/api/sources'
import { SpiderRepository } from '@/core/api/spiders'

const spiders = new SpiderRepository()

export default Vue.extend({
  components: {
    SourceFilter,
  },
  data: () => ({
    submitRequest: false,
    fetchRequest: false,
    selected: [],
    page: 1,
    pageCount: 1,
    items: [],
    itemsCount: 0,
    sortColumn: '',
    sortDescending: false,
    filter: {
      query: '',
      empty: false,
      activeParsing: true,
    },
    table: {
      headers: [
        {
          text: 'Источник',
          align: 'start',
          value: 'name',
        },
        {
          text: 'URL',
          value: 'url',
          width: '120px',
        },
        {
          text: 'Новостей',
          align: 'center',
          value: 'news_count',
          width: '120px',
        },
        {
          text: 'Парсеров',
          align: 'start',
          value: 'spider_count',
          width: '120px',
        },
      ],
    },
  }),
  computed: {
    loading() {
      return this.submitRequest || this.fetchRequest
    },
  },
  created() {
    this.fetch()
  },
  methods: {
    async fetch() {
      this.fetchRequest = true
      const { count, results, pages } = await fetchSources({
        page: this.page,
        pageSize: 100,
        ordering: this.sortDescending ? '-' + this.sortColumn : this.sortColumn,
        ...(this.filter as any),
      })

      this.clearSelection()
      this.items = results
      this.itemsCount = count
      this.pageCount = pages
      this.fetchRequest = false
    },
    submit() {
      this.submitRequest = true
      const ids = this.selected.map(x => x['id'])
      spiders
        .bulkCreate(ids)
        .then(() => {
          this.$toastSuccess.fire({
            title: 'Парсеры успешно созданы',
          })
          this.$store.dispatch('spiders/FETCH')
          this.fetch()
        })
        .catch(() => {
          this.$toastError.fire()
        })
        .finally(() => {
          this.submitRequest = false
        })
    },
    onPageChange(page: number) {
      this.page = page
      this.fetch()
    },
    onFilterChange() {
      this.fetch()
    },
    onSortChange() {
      this.fetch()
    },
    clearSelection() {
      this.selected = []
    },
  },
})
